import React from 'react';
import DataAccessHelper from '../Helper/DataAccessHelper';
import { useEffect, useState } from 'react';
import Footer from '../Components/Footer';
import '../Styles/GroupReservation.scss';
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import '../Styles/WeekSelection.scss';
import Disclaimer from '../Components/Disclaimer';
import DateHelpers from '../Helper/DateHelpers'
import CamperTypeSelection from '../Components/CamperTypeSelection';
import '../Styles/CardsforCamperType.scss';
import CampEventAndDateSelection from '../Components/CampEventAndDateSelection';
import GroupReservationTypeSelection from '../Components/GroupReservationTypeSelection';
import ReservationSpotSelection from '../Components/ReservationSpotSelection';
import ReservationReview from '../Components/ReservationReview';
import ReservationPayment from '../Components/ReservationPayment';
import { GroupPageOptions } from '../Constants/RegistrationPageOptions';
import { registrationType } from '../Constants/RegistrationType';
import GenerateRandomCode from "../Helper/GenerateRandomCode.js";
import { Helmet } from "react-helmet";
import { parseISO } from "date-fns";

function GroupReservation() {
   const navigate = useNavigate();
   const [eventAndDate, setEventAndDate] = useState({ groupCode: '' })
   const [selectedPage, setSelectedPage] = useState(GroupPageOptions.WeekSelection);
   const [week, setWeek] = useState();
   const [campEvent, setCampEvent] = useState('Select Camp Type');
   const [numberOfSpots, setNumberOfSpots] = useState("")
   const [fastTrack, setFastTrack] = useState({
      selectedOption: '',
      fastTrackPromo1: '',
      fastTrackPromo2: '',
      freeRoomOption: false,
   })
   const [isFastTrack, setIsFastTrack] = useState(false);
   const [paymentAmount, setPaymentAmount] = useState(0.00);
   const [account, setAccount] = useState();
   const [amountDue, setAmountDue] = useState(0.00);
   const [paymentType, setPaymentType] = useState('')

   let eventRegistrationType = registrationType.CombinationGroup

   // Retreats share this whole flow with the overnight camps and differ only in skipping Fast Track.
   const isRetreat = week?.camp_type === 'Retreat'

   async function validateAndProcessReservation(paymentIntentId) {
      console.log(paymentIntentId, "Payment intent id in the validate and process reservation function")
      try {
         const response = await fetch('/api/verify-payment', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ paymentIntentId }),
         });

         if (!response.ok) {
            console.error('Server returned an error verifying payment intent');
            return false
         }

         const data = await response.json();
         console.log('data', data)
         console.log('data.status', data.result.status)

         if (data.result.status === 'succeeded') {
            console.log("I think we have succeeded")
            // Stripe has confirmed success, now finalize reservation
            console.log("About to process reservation")
            ProcessReservation(paymentIntentId);
            return true
         } else {
            console.warn('Payment not confirmed. Status:', data.result.status);
            return false
         }
      } catch (err) {
         console.error('Error validating payment intent:', err);
      }
   }

   async function ProcessReservation(paymentIntentId) {
      var reservationResult = await AddReservation()
      console.log(reservationResult, "Reservation ID??")

      console.log("Payment amount", paymentAmount)
      // Written even at $0 so every reservation has a row in the ledger.
      await AddTransaction(reservationResult, paymentIntentId)
      navigate('/reservationpaymentsuccess', { state: { paymentAmount } })
   }


   async function AddReservation() {
      console.log("We are adding group reservation!")
      let accountId = account.group_account_id;
      let groupCode = GenerateRandomCode.GenerateCode();
      try {
         const groupReservation = await fetch('/groupreservation', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               accountId,
               groupCode,
               week,
               fastTrack,
               isFastTrack,
               numberOfSpots
            })
         })

         let reservationResult = await groupReservation.json();
         return reservationResult.data.groupReservation[0].reservation_id
      }
      catch (error) {
         console.log("Exception", error)
      }
   }

   async function AddTransaction(reservationId, paymentIntentId) {
      try {
         // Was /addreservationtransaction, which has no server route, so reservation payments were
         // never recorded. /addtransaction files it against reservation_id when no registId is sent.
         const transaction = await fetch('/addtransaction', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               transactionValue: paymentAmount,
               reservationId: reservationId,
               paymentType: paymentType,
               paymentIntentId
            })
         })
         let transactionResult = await transaction.json();
      } catch (error) {
         console.log("Exception", error)
      }
   }

   async function GetAccountInformation() {
      const accountResponse = await DataAccessHelper.getCurrentAccountInformation()
      setAccount(accountResponse.account)
      console.log('account response', accountResponse)
   }
   useEffect(() => {
      GetAccountInformation()
   }, []);
   useEffect(() => {
      if (!account) {
         return
      }
      console.log(account, "Here is the account information!")

   }, [account])

   // Choosing a retreat clears anything a Fast Track detour left behind. ReservationSpotSelection
   // sets paymentAmount to 100 when Fast Track is picked and nothing else ever puts it back, so a
   // user who took Fast Track for a camp, backed up, and switched to a retreat would hit Confirm on
   // a free hold and still have ProcessReservation write a $100 transaction for a card never charged.
   useEffect(() => {
      if (!isRetreat) {
         return
      }
      setIsFastTrack(false)
      setPaymentAmount(0.00)
   }, [week])

   return (
         <div className="groupRegPortalContainer">
            {selectedPage === GroupPageOptions.WeekSelection &&
               <CampEventAndDateSelection
                  eventRegistrationType={eventRegistrationType}
                  campEventSelection={campEvent} setCampEventSelection={w => setCampEvent(w)}
                  weekSelection={week} setWeekSelection={w => setWeek(w)}
                  eventAndDate={eventAndDate} setEventAndDate={setEventAndDate}
                  selectedPage={selectedPage}
                  setSelectedPage={setSelectedPage} />
            }
            {selectedPage === GroupPageOptions.ReservationTypeSelection &&
               <GroupReservationTypeSelection
                  selectedPage={selectedPage}
                  setSelectedPage={setSelectedPage}
                  isFastTrack={isFastTrack}
                  setIsFastTrack={setIsFastTrack} />
            }
            {selectedPage === GroupPageOptions.ReservationSpotSelection &&
                  <ReservationSpotSelection
                     numberOfSpots={numberOfSpots}
                     setNumberOfSpots={setNumberOfSpots}
                     setPaymentAmount={setPaymentAmount}
                     isFastTrack={isFastTrack}
                     fastTrack={fastTrack}
                     setFastTrack={setFastTrack}
                     selectedPage={selectedPage}
                     setSelectedPage={setSelectedPage}
                     week={week}
                     previousPage={isRetreat
                        ? GroupPageOptions.WeekSelection
                        : GroupPageOptions.ReservationTypeSelection}
                  />
            }
            {selectedPage === GroupPageOptions.Review &&
                  <ReservationReview
                     paymentAmount={paymentAmount}
                     amountDue={amountDue}
                     isFastTrack={isFastTrack}
                     fastTrack={fastTrack}
                     numberOfSpots={numberOfSpots}
                     week={week}
                     selectedPage={selectedPage}
                     setSelectedPage={setSelectedPage}
                     ProcessReservation={ProcessReservation}
                  />
            }
            {selectedPage === GroupPageOptions.ReservationPayment &&
                  <ReservationPayment
                     account={account}
                     amountDue={amountDue}
                     setAmountDue={setAmountDue}
                     paymentAmount={paymentAmount}
                     setPaymentAmount={setPaymentAmount}
                     paymentType={paymentType}
                     setPaymentType={setPaymentType}
                     numberOfSpots={numberOfSpots}
                     week={week}
                     validateAndProcessReservation={validateAndProcessReservation}
                     selectedPage={selectedPage}
                     setSelectedPage={setSelectedPage}
                  />
            }
         </div>
   )
}

export default GroupReservation;